import React, { useState } from "react";
import "./ourPolicies.scss";
import Layout from "components/Layouts/Layout";
import Footer from "components/Footer/Footer";
import Header from "components/Header/Header";
import { Accordion } from "react-bootstrap";

function OurPolicies() {
  const [activeItem, setActiveItem] = useState("0");

  return (
    <Layout searchVisible={true}>
      <div className="row">
        <Header />
      </div>
      <div className="row dashboard__main-container pb-5">
        <div className="row px-4 pt-4 font-lg fw-500 parent-text-primary">
          Our Policies
        </div>
        <div className="policies-wrapper mx-3 mt-4">
          <Accordion
            className="policies__accordion"
            activeKey={activeItem}
            defaultActiveKey="0"
          >
            <Accordion.Item className="policies__accordion_item" eventKey="0">
              <Accordion.Button
                className={`policies__accordion_button ${
                  activeItem === "0" ? "policies__accordion_button_active" : ""
                }`}
                onClick={() => setActiveItem("0")}
                as="div"
              >
                Pricing Policy
              </Accordion.Button>
              <Accordion.Body className="policies__accordion_body">
                <p className="heading">
                  Standard Tutoring Program for all new enrollments
                </p>
                <p>
                  The fee is refundable should the customer decide to cancel the
                  program during the money back guarantee trial period. The
                  initial textbook fee will be actual cost of the book plus
                  shipping charge ($75). This will be charged every time the
                  customer needs a different book, like when starting a new
                  grade in school or adding a new subject for tutoring if the
                  book is not available in our Library. The book shall remain
                  property of Growing Stars, Inc
                </p>
                <p>
                  <ul>
                    <li>
                      Online student assessment testing with a phone conference
                      and review from an Education Manager.{" "}
                    </li>
                    <li>
                      Initial online session demonstration with Growing Stars
                    </li>
                    <li>
                      Monthly progress reports available online via the Growing
                      Stars Parent Portal.{" "}
                    </li>
                    <li>
                      100% Guaranteed Money-Back offer if not completely
                      satisfied with our service (within the first 4 tutoring
                      sessions or two weeks, whichever occurs first.)
                    </li>
                    <li>
                      The program is billing monthly in advance. Price is based
                      on the specific monthly program selected.
                    </li>
                    <li>
                      Customer credit card info must be collected at the time of
                      enrollment. Payment by check not accepted.
                    </li>
                  </ul>
                </p>
                <p className="heading">
                  Programs for Math/Science/English with tutors based in Cochin,
                  India
                </p>
                <p>
                  In order to provide the best quality of service, and to
                  schedule teachers more efficiently so that the same tutor is
                  always available to a student for a subject, students need to
                  commit to a specific number of sessions every month.
                </p>
                <p>
                  Programs are set up in 4 session increments. Changes between
                  programs are normally only allowed between calendar months,
                  (may make exceptions if increasing hours). Any additional
                  sessions taken within a single month, above the amount stated
                  in the program the student is currently enrolled in, will be
                  billed at the appropriate program prorated amount.
                </p>
                <p>
                  Click the below button to see the subjects and tutoring
                  programs we offer.
                </p>
                <button className="parent-primary-button">
                  Subjects & Pricing
                </button>
                <p className="heading">Terms and Conditions</p>
                <p>
                  Cancelled classes: If the company cancels a session for any
                  unforeseen reason, the customer will be given the option of a
                  make-up session at his convenience or the charges will be
                  reimbursed. If the customer cancels one or more session(s) in
                  a month, a maximum of up to 2 canceled sessions can be
                  compensated either in the same month or the following month;
                  however the company cannot guarantee the time or the teacher.
                </p>
                <p>
                  See the Growing Stars cancellation/vacation policy for
                  details.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="policies__accordion_item" eventKey="1">
              <Accordion.Button
                onClick={() => setActiveItem("1")}
                as="div"
                className={`policies__accordion_button ${
                  activeItem === "1" ? "policies__accordion_button_active" : ""
                }`}
              >
                Billing Policy
              </Accordion.Button>
              <Accordion.Body className="policies__accordion_body">
                <div>
                  <p className="heading">General Billing Policy</p>
                  <p>
                    The customer must provide Growing Stars with a major credit
                    card account number at the time of registration, for a
                    customer account to be established. It is the general
                    billing policy of Growing Stars to charge every customer in
                    advance for the monthly tutoring program at the beginning of
                    each calendar month. The only exception to this is at the
                    very start of each student's program as explained below.
                    <br /> For the first calendar month of sessions, after the
                    first completed session, the customer will be charged the
                    pro-rated amount as per the tutoring program they have
                    enrolled in. Thereafter, the customer will be charged the
                    full monthly fee for the tutoring program they are enrolled
                    in at the beginning of each calendar month. Growing Stars
                    only uses electronic invoices and statements which are
                    issued on a monthly basis at the time the customer's credit
                    card is charged.
                  </p>
                  <p className="heading">Late Charges</p>
                  <p>
                    <ul>
                      <li>
                        If Growing Stars does not receive payment within 30
                        days, a $20 late fee will be charged to the customer's
                        account, along with interest to all outstanding account
                        balances at 3% per month. IN ADDITION, all future
                        tutoring sessions will be put on hold until the
                        customer's account balance is current.
                      </li>
                      <li>
                        For any payment that is declined or returned by the bank
                        for 'Insufficient Funds', the customer will be assessed
                        an additional $25 charge.
                      </li>
                    </ul>
                  </p>
                  <p className="heading">Collections</p>
                  <p>
                    All customer accounts that are 60 days past due will be sent
                    for immediate collections.
                  </p>
                  <p className="heading">Refunds</p>
                  <p>
                    The fee is refundable if the customer cancels the program
                    within 4 sessions or the two-week period from the student's
                    first tutoring session, whichever is earlier. After the
                    trial period is over, the customer may terminate the
                    contract by giving two (2) weeks' notice in writing or by
                    email to <b>ad@growingstars.com</b>. However, Growing Stars
                    services are purchased for a full calendar month, and hence
                    the termination will be in effect only from the first day of
                    the following calendar month. No refunds will be issued for
                    services already purchased for the current month, regardless
                    of whether some hours are utilized or not.
                  </p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="policies__accordion_item" eventKey="2">
              <Accordion.Button
                onClick={() => setActiveItem("2")}
                as="div"
                className={`policies__accordion_button ${
                  activeItem === "2" ? "policies__accordion_button_active" : ""
                }`}
              >
                Cancellation Policy
              </Accordion.Button>
              <Accordion.Body className="policies__accordion_body">
                <div className="font-md">
                  <p className="heading">
                    Tutoring Session Cancellation Policy
                  </p>
                  <p>
                    <b>Vacation Cancellation</b>
                  </p>
                  <p>
                    <ul>
                      <li>
                        If a customer takes a short-term vacation that is less
                        than a month, then he/she will still have to pay for
                        that month since we cannot schedule our teacher for
                        another student for such a short duration. Growing Stars
                        tutoring service is purchased for one full calendar
                        month anytime. Prorating for a partial calendar month is
                        permitted only in the first month of service or while
                        restarting the service after a long term vacation.
                      </li>
                      <li>
                        Vacations that last one month or longer are termed long
                        term vacations. However, a customer may take long term
                        vacations without being billed for one or more months by
                        giving notice before the start of the new billing cycle.
                        Long-term vacation cancellations apply only from the
                        beginning of a calendar month. For example, if a
                        customer wishes to take vacation from late June through
                        August, short-term vacation policy will apply for June
                        and long-term policy will apply for July and August.
                        However, the customer is not guaranteed the same rate
                        when he/she starts the program again. The prevailing
                        rates at that time will apply.
                      </li>
                      <li>
                        If the company cancels a session for any unforeseen
                        reason, the customer will be given the option of a
                        make-up session at his convenience or the charges will
                        be reimbursed.
                      </li>
                      <li>
                        If the student or parent cancels scheduled session(s)
                        due to any reason, we will provide a maximum of up to 2
                        compensatory session(s) against canceled sessions in a
                        month, but the company cannot guarantee the time or the
                        teacher. If the number of canceled sessions exceeds
                        2(two) per month, the customer shall not receive any
                        compensatory sessions for cancellations in excess of
                        2(two) per month. If a customer cancels a compensatory
                        session, that will not be compensated again.
                      </li>
                    </ul>
                  </p>
                  <p>
                    -These Rescheduled sessions should be taken either in the
                    same month or the following month.
                    <br />
                    -If the sessions are not utilized within the stipulated
                    time, the customer will have to forgo the unutilized
                    sessions.
                    <br />
                    (We strongly recommend that the student does not cancel any
                    session. Our sessions are prescheduled, and we offer the
                    same teacher to the student for all his (her) sessions (in
                    one subject) for maximum effectiveness of tutoring, good
                    student-tutor rapport, and the student's academic success.
                    Since the tutor's time is scheduled for various students, it
                    is difficult for us to find compensatory time slots from the
                    busy schedule of the tutor. However, we also understand that
                    the customer may have to cancel sometimes due to unforeseen
                    reasons. Besides, it is a fact that regular tutoring without
                    breaks helps with the student's academic success. Therefore,
                    our policy accommodates a maximum of 2(two) cancellations
                    per month.)
                  </p>
                  <p>
                    <ul>
                      <li>
                        The customer may terminate the program by giving two (2)
                        weeks' notice in writing or by email to
                        ad@growingstars.com. However, Growing Stars services are
                        purchased for a full calendar month, and hence the
                        termination will be in effect only from the first day of
                        the following calendar month. No refunds will be issued
                        for services already purchased for the current month,
                        regardless of whether some hours are utilized or not.
                      </li>
                    </ul>
                  </p>
                  <p>
                    <b>
                      How can you notify us in advance about cancelling a class?
                    </b>
                  </p>
                  <p>You can inform us about class cancellations by:</p>
                  <p>
                    <ul>
                      <li>
                        Logging on to the Parent Portal from the Growing Stars
                        website: https://www.growingstars.com/ with the parent
                        user id and password, and send an email to the teacher
                        or Education Manager. If you do not have your parent
                        user id and password, please feel free to call us at
                        1-800-499-4769 (GROW) and we will provide you with your
                        credentials.
                      </li>
                      <li>
                        Calling the Teaching Center directly at 1-800-499-4769
                        (GROW). Do not forget to leave a message if you cannot
                        get anybody on the line.
                      </li>
                      <li>E -mailing to ad@growingstars.com</li>
                    </ul>
                  </p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className="policies__accordion_item" eventKey="3">
              <Accordion.Button
                onClick={() => setActiveItem("3")}
                as="div"
                className={`policies__accordion_button ${
                  activeItem === "3" ? "policies__accordion_button_active" : ""
                }`}
              >
                Referral Policy
              </Accordion.Button>
              <Accordion.Body className="policies__accordion_body">
                <div className="font-md">
                  <p className="heading">
                    Customer Referral Program, Effective: 1st April, 2022
                  </p>
                  <p>
                    <b>Referral Program</b>
                  </p>
                  <p>
                    When a Current Customer refers a New Customer, the Referring
                    Customer earns a Referral Credit
                  </p>
                  <p>
                    Referring Customer will get an amount equivalent to the
                    billing amount of the New Customer (one month advance
                    billing) or the billing amount of the Referring Customer
                    whichever is less, subject to a maximum of $ 120
                  </p>
                  <p>
                    Referral Amount will be deducted from the Billing Amount of
                    the Referring Customer, on the third billing of the New
                    Customer, if both the Customer's accounts are in good
                    standing
                  </p>
                  <p>
                    If there are more than one Referral in a month, the balance
                    of credits will be applied in subsequent monthly billing
                  </p>
                  <p>
                    If the Current Customer refers 5 or more New Customers
                    within 3 months, Referring Customer earns double the reward,
                    that is Referral Credit will be applied in the Monthly
                    Billing for 10 months..
                  </p>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
      <Footer />
    </Layout>
  );
}

export default OurPolicies;
